import React, { useEffect, forwardRef } from 'react';
import { DateField as BubbleUIDateField } from '@klarna/bubble-ui';

/** Borderless version of Bubble UI's `DateField` */
export const DateField = forwardRef((props, ref) => {
  const { name } = props;

  useEffect(() => {
    /** @type {HTMLInputElement} */
    const node = document.getElementById(name);

    if (node) {
      if (node.parentElement && node.parentElement.parentElement) {
        node.parentElement.style.top = 0;
        node.parentElement.style.position = undefined;
        node.parentElement.style.borderWidth = 0;

        node.parentElement.parentElement.style.padding = 0;
        node.parentElement.parentElement.style.marginTop = 0;
        node.parentElement.parentElement.style.borderStyle = 'none none solid none';
        node.parentElement.parentElement.style.borderRadius = 0;
      }
    }
  }, []);

  return (
    <div ref={ref}>
      <BubbleUIDateField {...props} />
    </div>
  );
});

DateField.displayName = 'DateField';

DateField.propTypes = {
  ...BubbleUIDateField.propTypes,
};
